import React from "react";
import "./css/donate.css";

function Donate() {
  return (
    <section
      id="donate"
      className="home content-grid bg-tertiary spacer donate-section"
    >
      <div className="container">
        <div className="donate-shell">
          <span className="donate-eyebrow d-block mb-3">
            Support Menstrual Health Education
          </span>

          <h2 className="donate-title mb-4">
            Help girls feel informed, prepared, and empowered
          </h2>

          <div className="row align-items-stretch g-4 donate-content-row">
            <div className="col-12 col-lg-6">
              <div className="donate-content">
                <p className="donate-copy mb-4">
                  Research shows that better menstrual health education improves
                  confidence, self-esteem, and health advocacy. Your donation
                  helps support the education girls need to better understand
                  their bodies and advocate for their care.
                </p>

                <a
                  href="https://buy.stripe.com/9B64gz1Mf7XBbG05MYc7u09"
                  className="donate-button"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Donate Now
                </a>

                <p className="donate-trust mt-3 mb-0">
                  Secure donation via Stripe
                </p>
              </div>
            </div>

            <div className="col-12 col-lg-6">
              <div className="donate-stat-card">
                <div className="donate-stat-kicker">Why this matters</div>

                <div className="donate-stat-number">78%</div>

                <p className="donate-stat-text">
                  of girls say they learned more about a frog&apos;s body than
                  their own in school.
                </p>

                <p className="donate-footnote mb-0">
                  *2023 State of the Period study, commissioned by Thinx, Inc. &
                  PERIOD
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Donate;